<template>
  <div class="lm-loader">
    <div :class="[{loading: loading}]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import StudentPosterModule from "../store-mixin";

export default {
  name: "StudentPosterLoader",
  mixins: [StudentPosterModule()],
  data() {
    return {
      loading: true,
      img: '',
    }
  },
  watch: {
    mainStyle: {
      handler() {
        this.loading = true;
        clearTimeout(this._loading);
        this._loading = setTimeout(() => {
          this.loading = false;
        }, 6000);
      },
      immediate: true
    }
  },
  created() {
    if (this.$root.env === 'renderer') {
      this.loading = false;
    }
  },
  mounted() {
    let vm = this;
    if (this.$root.env !== 'frontend') {
      this.loading = false;
    } else {
      jQuery(window).load(function () {
        vm.loading = false
      });
    }
  },
  computed: {
    backgroundUrl() {
      return this.$canUseWebP() ? this.img : this.img.replace('.webp', '.png')
    },
  }
}
</script>

<style lang="scss" scoped>
.lm-loader {
  height: 100%;
  width: 100%;
  > div {
    height: 100%;
    width: 100%;
  }
  .loading {
    filter: blur(25px);
    width: 100%;
    height: auto;
  }
}
</style>
